<template>
  <DanhSachLogOtp />
</template>

<script>
import DanhSachLogOtp from "@/components/pages/quan-tri-he-thong/log/DanhSachLogOtp.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";

// Phase 8 UC17: wrapper route màn nhật ký OTP.
export default {
  name: "TrangNhatKyOtp",
  components: {
    DanhSachLogOtp,
  },
  created() {
    setBreadcrumb(`${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.NHAT_KY_OTP}`);
  },
};
</script>
